module.exports = __webpack_public_path__ + "static/img/both.243dc9c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/both.jpeg
// module id = 177
// module chunks = 1